import React from "react";

import {Configuration} from "./generated/configuration";
import {ApiExtractorCtrlApi} from "./generated/api";

import axios from 'axios';
import {serverUrl} from "./Serveur";

const config = new Configuration();
const axiosInstance = axios.create({});

const api = new ApiExtractorCtrlApi(config, serverUrl, axiosInstance);

export default class ExtractCtrl extends React.Component {

    static async bdnbAllPost(filtre, limit, offset, callback, onError) {
        api.apiBdnbAllPost(filtre, limit, offset).then((result) => {
            callback(result.data);
        }).catch(err => onError?.(err));
    }



    static async getDpes(filtre, limit, offset, callback, onError) {
        api.apiDpePost(filtre, limit, offset).then((result) => {
            callback(result.data);
        }).catch(err => onError?.(err));
    }

    static async getEtab(filtre, limit, offset, callback, onError) {
        api.apiEtabPost(filtre, limit, offset).then((result) => {
            callback(result.data);
        }).catch(err => onError?.(err));
    }

    static async getBatimentGroupeAdresses(filtre, limit, offset, callback, onError) {
        api.apiBdnbBatimentGroupeAdressesPost(filtre, limit, offset).then((result) => {
            callback(result.data);
        }).catch(err => onError?.(err));
    }

    static async getBatimentGroupe(filtre, limit, offset, callback, onError) {
        api.apiBdnbBatimentGroupePost(filtre, limit, offset).then((result) => {
            callback(result.data);
        }).catch(err => onError?.(err));
    }

    static async getBatimentGroupeRnc(filtre, limit, offset, callback, onError) {
        api.apiBdnbBatimentGroupeRncPost(filtre, limit, offset).then((result) => {
            callback(result.data);
        }).catch(err => onError?.(err));
    }

    static async getBatiments(filtre, limit, offset, callback, onError) {
        api.apiBdnbBatimentsPost(filtre, limit, offset).then((result) => {
            callback(result.data);
        }).catch(err => onError?.(err));
    }

    static async getParcelles(filtre, limit, offset, callback, onError) {
        api.apiBdnbParcellesPost(filtre, limit, offset).then((result) => {
            callback(result.data);
        }).catch(err => onError?.(err));
    }

    static async getProp(filtre, limit, offset, callback, onError) {
        api.apiBdnbPropPost(filtre, limit, offset).then((result) => {
            callback(result.data);
        }).catch(err => onError?.(err));
    }

    static async getBatimentGroupeAdresse(filtre, limit, offset, callback, onError) {
        api.apiBdnbBatimentGroupeAdressePost(filtre, limit, offset).then((result) => {
            callback(result.data);
        }).catch(err => onError?.(err));
    }

    static async getBatimentConstruction(filtre, limit, offset, callback, onError) {
        api.apiBdnbBatimentConstructionPost(filtre, limit, offset).then((result) => {
            callback(result.data);
        }).catch(err => onError?.(err));
    }

    static async getBatimentGroupeSyntheseProprieteUsage(filtre, limit, offset, callback, onError) {
        api.apiBdnbBatimentGroupeSyntheseProprieteUsagePost(filtre, limit, offset).then((result) => {
            callback(result.data);
        }).catch(err => onError?.(err));
    }

    static async getRnc(filtre, limit, offset, callback, onError) {
        api.apiRncPost(filtre, limit, offset).then((result) => {
            callback(result.data);
        }).catch(err => onError?.(err));
    }


    static async getListOfCommuneByEpci(codeEpci, limit, offset, callback, onError) {
        api.apiListEpciGet(codeEpci).then((result) => {
            callback(result.data);
        }).catch(err => onError?.(err));
    }

}
